export const LOCATIONS = {
  MERCH_CARD: 'merch-card',
  CALCULATOR: 'calculator',
  SPLASH_PAGE_CARD: 'splash-page-card',
  STARTER_SUITE_CARD: 'starter-suite-card',
  SUITE_CARD: 'suite-card',
  FREE_CARD: 'free-card',
  SUITE_CALCULATOR: 'suite-calculator',
  CMS_CARD: 'cms-card',
  MIGRATE_YOUR_SITE: 'migrate-your-site',
  MC_SIDEGRADE_MODAL: 'mc-sidegrade-modal',
  CREATE_A_BUNDLE: 'create-a-bundle',
  BUNDLE_CARD: 'bundle-card',
  ADD_ON_CARD: 'add-on-card',
  PAID_VS_FREE_USERS_MODAL: 'paid-vs-free-users-modal',
  PRODUCT_PAGE_HEADER: 'product-page-header',
  APP: 'pricing-pages',
  WHY_GO_HUBSPOT_CARD: 'why-go-hubspot-card',
  INTERSTITIAL: 'interstitial',
  INTERSTITIAL_HEADER: 'interstitial-header',
  SUITE_FEATURE_TABLE_HEADER: 'suite-feature-table-header',
  BUNDLE_FEATURE_TABLE_HEADER: 'bundle-feature-table-header',
  CLEARBIT_BANNER: 'clearbit-banner',
  ONBOARDING_CARD: 'onboarding-card',
  MARKETING_PLUS_CARD: 'marketing-plus-card',
  FAQ: 'faq',
  UPGRADE_PAGE_HEADER: 'upgrade-page-header',
  UPGRADE_PAGE_FEATURE_TABLE: 'upgrade-page-feature-table',
  SSM0003_VAR_B_STARTER_CARD: 'ssm0003-var-b-starter-card',
  STARTER_CUSTOMER_PLATFORM_UPSELL_MERCH_CARD: 'starter-customer-platform-upsell-merch-card',
  MARKETING_HUB_ENTERPRISE_PRICE_CHANGE_BANNER: 'marketing-hub-enterprise-price-change-banner'
};
// individual exports for backwards compatibility
export const {
  MERCH_CARD,
  CALCULATOR,
  SPLASH_PAGE_CARD,
  STARTER_SUITE_CARD,
  SUITE_CARD,
  FREE_CARD,
  SUITE_CALCULATOR,
  CMS_CARD,
  MIGRATE_YOUR_SITE,
  MC_SIDEGRADE_MODAL,
  CREATE_A_BUNDLE,
  BUNDLE_CARD,
  ADD_ON_CARD,
  PAID_VS_FREE_USERS_MODAL,
  PRODUCT_PAGE_HEADER,
  APP,
  WHY_GO_HUBSPOT_CARD,
  INTERSTITIAL,
  SUITE_FEATURE_TABLE_HEADER,
  CLEARBIT_BANNER,
  ONBOARDING_CARD,
  BUNDLE_FEATURE_TABLE_HEADER,
  MARKETING_PLUS_CARD,
  UPGRADE_PAGE_HEADER,
  UPGRADE_PAGE_FEATURE_TABLE,
  SSM0003_VAR_B_STARTER_CARD,
  STARTER_CUSTOMER_PLATFORM_UPSELL_MERCH_CARD
} = LOCATIONS;
export const SCREENS = {
  PRODUCTS_PLANS: 'products-plans',
  CREATE_BUNDLE: 'create-bundle',
  GROWTH_SUITE: 'growth-suite',
  SUITE: 'suite',
  ERROR: 'error',
  CONTACT_CONFIRMATION: 'contact-confirmation',
  SUITE_CONTACT_CONFIRMATION: 'suite-contact-confirmation',
  MC_CONTACT_CONFIRMATION: 'mc-contact-confirmation',
  CONTACT_SALES: 'contact-sales',
  LEGACY_INTERSTITIAL: 'legacy-interstitial',
  SUITE_STARTER: 'suite-starter',
  UPGRADE_PAGE: 'upgrade-page',
  ADD_ONS: 'add-ons'
};
export const UPGRADE_PAGES = {
  ADD_ON: 'add-on',
  STARTER: 'starter',
  SUITE_STARTER: 'suite-starter',
  PROFESSIONAL: 'professional',
  ENTERPRISE: 'enterprise',
  TRIAL: 'trial',
  COMPARE_PROFESSIONAL: 'compare-professional',
  ADD_ONS: 'add-ons'
};
export const SUBSCREENS = {
  DEFAULT: 'default',
  ADD_SEATS: 'add-seats',
  ADD_REMAINING_SEATS: 'add-remaining-seats',
  ONBOARDING: 'onboarding',
  BUY_ADDITIONAL_MARKETING_CONTACTS: 'buy-additional-marketing-contacts',
  BUY_ADDITIONAL_SEATS: 'buy-additional-seats'
};
export const FLOWS = {
  FREE_TO_STARTER: 'free-to-starter',
  FREE_TO_PRO: 'free-to-pro',
  STARTER_TO_PRO: 'starter-to-pro',
  BUY_ADDITIONAL_SEATS: 'buy-additional-seats',
  BUY_ADDITIONAL_MARKETING_CONTACTS: 'buy-additional-marketing-contacts'
};